import { formatPerformedValue } from "../domain/loadDisplay";
import { suggestedCopy } from "../domain/suggestedCopy";

// The app's "recent history" mark (the same drawing as the TRAIN hub's history
// control): a clock face with a rewind arrow. Decorative; the words carry it.
function LastIcon() {
  return (
    <svg
      className="lz-workout-set-guidance__icon"
      data-icon="history-recent"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="7.75" />
      <path d="M4.25 4.75v4.5h4.5M4.45 9.15A8.25 8.25 0 0 1 12 3.75" />
      <path d="M12 7.5V12l3 2" />
    </svg>
  );
}

// The per-set guidance row (§13.10): LAST first, as plain historical text,
// then Suggested (first working set only) as a separate trailing element.
// Renders nothing, and reserves no space, when there is neither.
export default function SetGuidanceRow({
  measurementType = "REPS",
  last = null,
  suggested = null,
  targetRir = null,
  disabled = false,
  onFill,
}) {
  const lastText = last
    ? formatPerformedValue({
        measurementType,
        load: last.load,
        reps: last.reps,
        seconds: last.seconds,
        rir: last.rir,
      })
    : "";
  const copy = suggestedCopy(suggested, { targetRir });
  if (!lastText && !copy) return null;

  const suggestedBody = copy ? (
    <>
      {copy.arrow ? <span className="lz-workout-suggested__arrow" aria-hidden="true">{copy.arrow}</span> : null}
      <span className="lz-workout-suggested__value" aria-hidden="true">{copy.value}</span>
      {copy.detail ? <span className="lz-workout-suggested__detail" aria-hidden="true">· {copy.detail}</span> : null}
      <span className="lz-v2-visually-hidden">{copy.label}</span>
    </>
  ) : null;

  return (
    <div className="lz-workout-set-guidance" data-testid="set-guidance">
      {lastText ? (
        <span className="lz-workout-set-guidance__last">
          <LastIcon />
          <span className="lz-v2-visually-hidden">Last time: </span>
          <span>{lastText}</span>
        </span>
      ) : null}
      {copy && copy.fills ? (
        <button
          type="button"
          className="lz-workout-suggested lz-workout-suggested--action"
          data-kind={suggested.kind}
          data-direction={suggested.direction}
          disabled={disabled}
          onClick={() => onFill?.(suggested.load)}
        >
          {suggestedBody}
        </button>
      ) : null}
      {copy && !copy.fills ? (
        <span
          className="lz-workout-suggested"
          data-kind={suggested.kind}
          data-direction={suggested.direction}
        >
          {suggestedBody}
        </span>
      ) : null}
    </div>
  );
}
